import { Loader } from "@components/loader/loader"
import { defineMessage, Trans } from "@lingui/macro"
import DeviceDetector from "device-detector-js"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useHistory } from "react-router-dom"

import AndroidIcon from "~/assets/Android.svg"
import IosIcon from "~/assets/BlackIos.svg"
import BluePlus from "~/assets/BluePlus.svg"
import FiveStars from "~/assets/FiveStars.png"
import MastercardPure from "~/assets/MastercardPure.svg"
import PaypalIcon from "~/assets/PayPal.svg"
import VisaPure from "~/assets/VisaPure.svg"
import { Block } from "~/components2/atoms/Block"
import { Button } from "~/components2/atoms/Button"
import { Input } from "~/components2/atoms/Input"
import { List } from "~/components2/atoms/List"
import { TextBody, TextWithIcon, Colored } from "~/components2/atoms/Text"

import { useQueryParams } from "~/hooks/use-query-params"
import { useWindowDimensions } from "~/hooks/use-window-dimensions"
import { useWindowLayout } from "~/hooks/use-window-layout"
import { amplitudeService } from "~/services/amplitude"
import { analytics } from "~/services/analytics"
import { DPaywallType } from "~/services/config/config-types"
import { cookies } from "~/services/cookies"
import { i18nCustom } from "~/services/service/i18n-service"
import { useAuthContext } from "~/subscriptions-web/context"
import { PayPalButton } from "~/subscriptions-web/paypal/paypal-button"
import { callFirebaseFunction } from "~/subscriptions-web/server-api/call-firebase-function"
import { usePaywall } from "../../use-paywall"
import { PrePaywall } from "../atoms/prepaywall"
import { PrePaywallTime } from "../atoms/prepaywall-time"
import { PriceAfterTrialWeekly } from "../atoms/price-after-trial-weekly"
import { PriceToday } from "../atoms/price-today"
import { TrialInformation } from "../atoms/trial-info"
import { Promocode } from "../promocode"

import {
	Wrapper,
	ContentWrapper,
	Content,
	ExpandedArea,
	MediumBlock,
	charlieBenefits,
	PaymentBubble,
	PaymentTitle,
	TimerBox,
	PaywallFooter,
	TryTitle,
	MarketsSimple,
	MarketBubble,
	PriceInfo,
	PaymentMethods,
	PaymentMethod,
	PayPalButtonWrapper,
	PayPalButtonContainer,
} from "../styles"
import { PaywallProps } from "../types"
import RecommendsGlobe from "./assets/recommends.png"
import ReviewIcon from "./assets/review.png"
import { reviews, reviewsMan } from "./reviews"
import { EchoUserReviews } from "./styles"

export function JuliettPaywall({ onNext }: PaywallProps) {
	const layout = useWindowLayout()
	const timerRef = useRef<HTMLDivElement>(null)
	const timeRef = useRef<HTMLDivElement>(null)
	const addressZipRef = useRef<HTMLInputElement>(null)
	const onboardingType = useQueryParams().get("onboardingType")

	const windowSize = useWindowDimensions()

	const [reviewsHidden, setReviewsHidden] = useState(true)
	const toggleReviews = useCallback(() => {
		setReviewsHidden((v) => !v)
	}, [])
	const shownReviews = useMemo(() => {
		const reviewsByOnboardingType = onboardingType === "man" ? reviewsMan : reviews

		return reviewsHidden ? reviewsByOnboardingType.slice(0, 3) : reviewsByOnboardingType
	}, [reviewsHidden, onboardingType])

	const {
		product,
		paywallPrice,
		agreed,
		setAgreed,
		timeLeft,
		visibleTimer,
		paywallWeeklyPrice,
		createPayPalSubscription,
		handlePayPalApprove,
		handleScroll,
		logPaypalEvent,
		webPrepaywallType,
		createPaddleSubscription,
		//		paddleProductId,
	} = usePaywall(DPaywallType.Juliett, addressZipRef, timeRef)

	useEffect(() => {
		if (paywallPrice) {
			//console.log("+++PAYWALL PRICE 0___", paywallPrice)
		}
	}, [paywallPrice])

	useEffect(() => {
		if (timerRef.current) {
			if (visibleTimer) {
				timerRef.current.style.top = "12px"
			} else {
				timerRef.current.style.top = "-40px"
			}
		}
	}, [visibleTimer])

	useEffect(() => {
		if (agreed) {
			if (timeRef.current) {
				timeRef.current.scrollIntoView({
					behavior: "smooth",
					block: "start",
				})
			}
		}
	}, [agreed])

	defineMessage({ message: "Paying..." })
	defineMessage({ message: "View more" })
	defineMessage({ message: "Show less" })
	defineMessage({ message: "Day" })
	defineMessage({ message: "Days" })

	shownReviews.forEach((r) => {
		defineMessage({ message: r.name })
		defineMessage({ message: r.message })
	})

	//console.log("___PRODUCTTT___", product)

	const paywallForm = document.getElementById("paywall-form")

	const history = useHistory()

	const { currentUser } = useAuthContext()

	const fbc = cookies.get("_fbc")
	const fbp = cookies.get("_fbp")
	const amplitudeDeviceId = amplitudeService.deviceId
	const amplitudeUserId = amplitudeService.userId

	//console.log("+++CURRENT USER+++", currentUser)

	const [isEmailSent, setIsEmailSent] = useState(false)

	const sendEmail = useCallback(async () => {
		if (!isEmailSent) {
			setIsEmailSent(true)
			await callFirebaseFunction("sendManualEmailUser", { email: localStorage.getItem("email") })
		}
	}, [isEmailSent])

	useEffect(() => {
		if (currentUser) {
			const unformattedPassthrough = {
				priceId: product.priceId,
				amount: product.trial.amount,
				currency: product.trial.currency,
				user_id: currentUser.uid,
				email: localStorage.getItem("email"),
				fbc,
				fbp,
				amplitudeDeviceId,
				amplitudeUserId,
			}

			const passthrough = JSON.stringify(unformattedPassthrough)

			if (window.Paddle.Checkout && currentUser && currentUser.uid && product) {
				// console.log("+++PASSTHROUGH+++", passthrough, typeof passthrough)
				// console.log("+++CHECKOUT LOADED+++", window.Paddle.Checkout, window.Paddle.Options)
				// console.log("+++PAYWALL FORM+++", paywallForm)

				if (paywallForm && process.env.REACT_APP_PADDLE_PRODUCT_ID) {
					createPaddleSubscription()
						.then((response) => {
							//console.log("+++PAD RESPONSE 2+++", response)

							if (response.response && response.success) {
								window.Paddle.Checkout.open({
									override: response.response.url,
									country: "US",
									method: "inline",
									frameTarget: "paywall-payment-form",
									frameInitialHeight: 416,
									frameStyle: "width:100%; background-color: transparent; border: none;",

									successCallback: () => {
										analytics.track("purchase", {
											product: { ...product, trial: { ...product.trial, amount: 5999 } },
											orderID: "",
										})
										analytics.track("checkout", {
											...product,
											trial: { ...product.trial, amount: 5999 },
										})
										analytics.track("start_trial", {
											...product,
											trial: { ...product.trial, amount: 5999 },
										})
										sendEmail()
										history.push("/confirm")
										//console.log("+++paddle success+++")
									},
								})
							}
						})
						.catch((err) => console.log("+++PAD ERR+++", err))
					//console.log("+++CHECKOUT LOADED 2+++", window.Paddle.Checkout)
				}
			}
		}
	}, [
		paywallForm,
		currentUser,
		amplitudeDeviceId,
		amplitudeUserId,
		fbc,
		fbp,
		product,
		createPaddleSubscription,
		history,
		sendEmail,
	])

	if (window.Paddle.Checkout && window.Paddle.Checkout.Close) {
		amplitudeService.logEvent("[Paddle Test] Paddle checkout closed")
	}
	if (window.Paddle.Checkout && window.Paddle.Checkout.Complete) {
		amplitudeService.logEvent("[Paddle Test] Paddle checkout completed")
		sendEmail()
		history.push("/confirm")
	}
	if (window.Paddle.Checkout && window.Paddle.Checkout.User && window.Paddle.Checkout.User.Subscribed) {
		amplitudeService.logEvent("[Paddle Test] Paddle user subscribed")
		sendEmail()
		history.push("/confirm")
	}
	if (window.Paddle.Checkout && window.Paddle.Checkout.Error) {
		amplitudeService.logEvent("[Paddle Test] Paddle checkout error")
	}
	if (window.Paddle.Checkout && window.Paddle.Checkout.PaymentComplete) {
		amplitudeService.logEvent("[Paddle Test] Paddle payment completed")
		sendEmail()
		history.push("/confirm")
	}

	const deviceDetector = new DeviceDetector()
	const userAgent = globalThis.navigator.userAgent
	const device = deviceDetector.parse(userAgent)
	//console.log("+++USER AGENT+++", device)
	const emailContent = `%0D%0A%0D%0AClient: ${device.client?.type} ${device.client?.name} ${device.client?.version}, %0D%0ADevice: ${device.device?.type} ${device.device?.brand} ${device.device?.model}, %0D%0AOS: ${device.os?.name} ${device.os?.version}`

	if (webPrepaywallType && product) {
		return (
			<Wrapper windowHeight={windowSize.height}>
				<ContentWrapper id="wrapper" onScroll={handleScroll}>
					<PrePaywall
						webPrepaywallType={webPrepaywallType}
						agreed={agreed}
						setAgreed={setAgreed}
						paywallPrice={paywallPrice!}
					/>
					<Content windowHeight={windowSize.height}>
						{agreed && (
							<ExpandedArea>
								<TimerBox ref={timerRef}>
									<p>
										<Trans>Plan reserved for</Trans>{" "}
									</p>
									<span>
										{Math.floor(timeLeft / 60)}:{timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60}
									</span>
								</TimerBox>
								<PrePaywallTime
									windowHeight={windowSize.height}
									webPrepaywallType={webPrepaywallType}
									ref={timeRef}
									timeLeft={timeLeft}
								/>
								<TryTitle layout={layout} size="big" margin="-40px 0 14px" centered>
									<Trans>Try</Trans> {product?.trial?.trialPeriodDays} <Trans>Trial</Trans>{" "}
									{(product?.trial?.trialPeriodDays ?? 0) > 1 ? i18nCustom._("Days") : i18nCustom._("Day")} <br />
									<Trans>with</Trans>{" "}
									<Colored color="">
										<Trans>Glowbe Course</Trans>
									</Colored>
								</TryTitle>

								<span id="benefits">
									<MediumBlock>
										<List align="left" items={charlieBenefits} />
									</MediumBlock>
								</span>

								<MediumBlock>
									<PriceToday product={product} paywallPrice={paywallPrice} />

									<PriceInfo>{product.labels.description}</PriceInfo>

									<PriceAfterTrialWeekly
										isSpecialOffer
										paywallWeeklyPrice={paywallWeeklyPrice}
										paywallPrice={paywallPrice}
									/>

									<Promocode
										closed={({ openPromocode }) => (
											<TextWithIcon
												color="#5856D6"
												margin="24px 0 40px"
												icon={BluePlus}
												centered
												style={{ whiteSpace: "nowrap" }}
												onClick={openPromocode}
											>
												<Trans>Add a promocode</Trans>
											</TextWithIcon>
										)}
										opened={({ promocode, onChangePromocode, applyPromocode }) => (
											<Block margin="20px 0 8px">
												<TextBody size="big" color="rgba(130,134,145,0.5)">
													<Trans>Promocode</Trans>
												</TextBody>
												<Input
													placeholder="6-digits code"
													value={promocode}
													type="other"
													onChange={onChangePromocode}
													width="100%"
													maxLength={6}
												/>
												<Button
													disabled={promocode.length === 0}
													color="blue"
													title="Apply"
													width="100%"
													onClick={applyPromocode}
												/>
											</Block>
										)}
										applied={({ promocode }) => (
											<TextBody centered size="big" margin="20px 0 40px">
												<Trans>You've successfuly applied promocode</Trans>{" "}
												<Colored color="#5856d6">{promocode.toUpperCase()}</Colored>{" "}
												<Trans>and recieved one more month</Trans>{" "}
												<Colored color="#5856d6">
													<Trans>for free.</Trans>
												</Colored>{" "}
												<Trans>Thank you!</Trans>
											</TextBody>
										)}
									/>

									<EchoUserReviews>
										<div className="title">
											<Trans>User reviews</Trans>
										</div>
										<div className="reviews">
											{shownReviews.map((r) => (
												<div key={r.name} className="review">
													<div className="row">
														<img className="avatar" src={r.avatar} alt={r.name} />
														<div className="col">
															<div className="name">
																{i18nCustom._(r.name)}
																<img src={ReviewIcon} alt="" />
															</div>
															<div className="recommends">
																<img src={RecommendsGlobe} alt="" />
																<span>
																	<Trans>recommends</Trans>{" "}
																	<span className="power">
																		<Trans>Glowbe</Trans>
																	</span>
																</span>
															</div>
														</div>
													</div>
													<div className="message">{i18nCustom._(r.message)}</div>
												</div>
											))}
										</div>
										<button className="view-more" onClick={toggleReviews}>
											{reviewsHidden ? i18nCustom._("View more") : i18nCustom._("Show less")}
										</button>
									</EchoUserReviews>

									<PaymentBubble>
										<PaymentTitle>
											<Trans>Payment Info</Trans>
										</PaymentTitle>
										<div id="paywall-form" className="paywall-payment-form"></div>
									</PaymentBubble>

									<MarketsSimple>
										<div style={{ marginTop: 24 }}>
											<span>
												<img alt="" src={AndroidIcon} />
												<p>
													<Trans>Google Play</Trans>
												</p>
											</span>
											<span>
												<img alt="" src={IosIcon} />
												<p>
													<Trans>App Store</Trans>
												</p>
											</span>
										</div>
										<div>
											<MarketBubble>
												<img alt="" src={FiveStars} />
												<p>
													4.8<span>/5</span>
												</p>
											</MarketBubble>
										</div>
										<div>
											<MarketBubble>
												<p>
													1M+{" "}
													<span>
														<Trans>downloads</Trans>
													</span>
												</p>
											</MarketBubble>
											<MarketBubble>
												<p>
													12K{" "}
													<span>
														<Trans>5-star ratings</Trans>
													</span>
												</p>
											</MarketBubble>
										</div>
									</MarketsSimple>

									<TrialInformation
										paywallType={DPaywallType.Juliett}
										trialPeriodDays={product.trial.trialPeriodDays}
										paywallPrice={paywallPrice}
									/>
								</MediumBlock>

								<PaywallFooter>
									<p>
										<Trans>Copyright</Trans> ® 2022 Glowbe.
										<br />
										<Trans>All Rights Reserved</Trans>
										<br />
										<br />
										<a
											href={`mailto:support@glowbe.com?subject=Need help&body=${emailContent}`}
											target="_blank"
											rel="noreferrer"
										>
											<Trans>Get Support</Trans>
										</a>
									</p>
								</PaywallFooter>
							</ExpandedArea>
						)}
					</Content>
				</ContentWrapper>
			</Wrapper>
		)
	} else return <Loader />
}
